export default "__VITE_ASSET__C15N$iPT__"